<template>
  <div class="c-vote-intro">
    <div class="c-vote-intro__cols">
      <div class="c-vote-intro__col">
        <div class="c-voted-box">
          <p class="c-voted-box__number">{{ averageRatingFormatted }}</p>
          <c-stars :rating="averageRating" />
          <div class="c-voted-box__btn">
            <p class="c-voted-box__count">{{ratings.length }} ocen</p>
            <a @click="$emit('addReviewClicked')" class="c-btn c-btn--secondly c-btn--theme-6 u-text-uppercase f_right c-btn--revieving c-btn--border-radius-full">
              <span class="c-btn__wrap">
                <span class="c-btn__label">Dodaj opinię</span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="c-vote-intro__col">
        <div class="c-progresses-list">
          <c-progress v-for="r in ratingsWithShare" :key="r.rating" :label="r.rating" :progress-value="r.count"
                      :progress-percent="r.share" :progress-color="r.color" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {roundFloatNumberToOnePlace, calculateAverage} from '@/shared/math'
import CProgress from '@/components/CProgress'
import CStars from '@/components/CStars'

const ratingColors = ['#cbcbcb', '#f0825c', '#f0825c', '#6ed2b5', '#e4c724']

export default {
  components: {
    CProgress,
    CStars
  },

  props: ['ratings'],

  computed: {
    averageRating () {
      const averageRating = calculateAverage(this.ratings)
      return roundFloatNumberToOnePlace(averageRating)
    },

    averageRatingFormatted () {
      return this.averageRating.toLocaleString()
    },

    ratingsWithShare () {
      const ratingsCount = this.ratings.length
      const shares = [0, 0, 0, 0, 0]

      this.ratings.forEach(rating => shares[rating - 1]++)

      return shares.map((count, index) => {
        return {
          rating: index + 1,
          share: count / ratingsCount * 100,
          count: count,
          color: ratingColors[index]
        }
      }).reverse()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductPage/ReviewsSummary.vue